import { useNavigate } from "react-router-dom";
import { useSession } from "./useSession";
import { useStates } from "./useStates";
import { init as initResilienza } from "@monforte/resilienza-package";
import { ApiService as api } from "../services/ApiService";
import { isProd } from "../services/env";
import urls from "../config/urls.json";

const clearedFilialeFields = {
    id_filiale_direct: null,
    codFiliale_external: null,
    filiali: null,
    filialeScelta: null,
    filialeSceltaIdx: 0,
    disponibilita: null,
    dataScelta: null,
    orari: null,
    orarioScelto: null,
    ricontattoLuogo: null,
};

export const useExternalParams = () => {
    const navigate = useNavigate();
    const { batchUpdate, canWeSkipLuogoPage } = useSession();
    const { states, setCurrentState } = useStates();

    const handleExternalParams = async () => {
        return new Promise(async (res, rej) => {
            initResilienza({
                url: process.env.REACT_APP_RESILIENZA_URL,
                defaultTimeout: process.env.REACT_APP_RESILIENZA_TIMEOUT,
            });

            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            if (!Object.keys(params).length) {
                res();
                return;
            }

            let mergableFields = {
                prodotto: "prestito",
            };

            const readyFields = ["utm_history", "utm_term", "mediacode", "utm_source", "utm_medium", "utm_campaign", "utm_date", "utm_content", "prodotto"];
            readyFields.forEach((field) => {
                if (Object.keys(params).includes(field)) {
                    mergableFields[field] = params[field];
                }
            });

            const codFiliale = params["id_filiale"] || params["id_filiale_direct"];
            if (codFiliale) {
                try {
                    const coordinate = await api.TrovaFiliale({ IdFiliale: codFiliale });
                    const filialiResult = await api.TrovaFiliali3({
                        latitude: coordinate.latitude,
                        longitude: coordinate.longitude,
                        placeType: mergableFields["placeType"],
                        city: mergableFields["city"],
                        cap: mergableFields["cap"],
                    });

                    const filialeScelta = (filialiResult.filiali || []).filter((filiale) => filiale.codFiliale == codFiliale)[0];

                    if (!filialeScelta) {
                        throw new Error("Filiale non trovata in TrovaFiliali3");
                    }

                    const orari = filialeScelta.orariDisponibili || [];
                    mergableFields = {
                        ...mergableFields,
                        id_filiale_direct: codFiliale,
                        codFiliale_external: codFiliale,
                        filialeSceltaIdx: 0,
                        filiali: [filialeScelta],
                        filialeScelta,
                        disponibilita: filialeScelta.days,
                        dataScelta: filialeScelta.days[0],
                        ricontattoLuogo: filialiResult.ricontatto,
                        orari,
                        orarioScelto: { idx: orari.findIndex((item) => item.disponibile === true) },
                    };
                } catch (error) {
                    if (!isProd()) console.log(error);
                    mergableFields = {
                        ...mergableFields,
                        ...clearedFilialeFields,
                    };
                }
            }

            batchUpdate(mergableFields);

            if (canWeSkipLuogoPage()) {
                setCurrentState(states.FETCH_FILIALI_END);
                res(() => {
                    navigate(urls.filiali.path, { replace: true });
                });
                return;
            }

            res();
        });
    };

    return {
        handleExternalParams,
    };
};
